export default "__VITE_ASSET__CsjO7Xnb__"